// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  background: #f8fafc;
  line-height: 1.6;
}

.app-container {
  min-height: 100vh;
  position: relative;
}

/* Authentication Layout */
.auth-layout {
  display: flex;
  min-height: 100vh;
}

.auth-image-section {
  flex: 1 1;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
}

.auth-image-section img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
}

.auth-form-section {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: white;
}

.auth-card {
  width: 100%;
  max-width: 400px;
  padding: 2rem;
}

/* Brand Section */
.brand-section {
  text-align: center;
  margin-bottom: 2rem;
}

.brand-logo {
  margin-bottom: 1.5rem;
}

.brand-name {
  display: block;
  font-size: 1.8rem;
  font-weight: 800;
  color: #1e293b;
  letter-spacing: 1px;
  margin-bottom: 0.25rem;
}

.brand-tagline {
  display: block;
  font-size: 0.85rem;
  color: #64748b;
  font-style: italic;
}

.auth-title {
  color: #3b82f6;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Form Styles */
.auth-form {
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  color: #374151;
  font-weight: 500;
  font-size: 0.9rem;
}

.form-input {
  width: 100%;
  padding: 0.875rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: #f9fafb;
}

.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.password-input-container {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.25rem;
}

.password-toggle:hover {
  color: #374151;
}

/* Button Styles */
.btn {
  padding: 0.875rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  margin-bottom: 1rem;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.btn-primary:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-secondary {
  background: #6b7280;
  color: white;
  margin-right: 0.5rem;
}

.btn-secondary:hover {
  background: #4b5563;
}

.btn-danger {
  background: #ef4444;
  color: white;
}

.btn-danger:hover {
  background: #dc2626;
}

.btn-link {
  background: none;
  color: #3b82f6;
  border: none;
  text-decoration: none;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
}

.btn-link:hover {
  color: #2563eb;
  text-decoration: underline;
}

/* Switch Text */
.switch-text {
  text-align: center;
  color: #6b7280;
  font-size: 0.95rem;
}

/* Footer */
.footer-text {
  text-align: center;
  font-size: 0.8rem;
  color: #9ca3af;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #f3f4f6;
}

.footer-link {
  color: #3b82f6;
  text-decoration: none;
}

.footer-link:hover {
  text-decoration: underline;
}

/* Header Controls */
.header-controls {
  position: fixed;
  top: 1.5rem;
  right: 1.5rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.session-error {
  text-align: center;
  padding: 10px;
  color: red;
  font-weight: 500;
}

/* Dashboard Styles */
.dashboard-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 2rem;
  padding-top: 5rem;
}

.dashboard-header {
  text-align: center;
  margin-bottom: 2rem;
}

.dashboard-header h1 {
  color: #1e293b;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.welcome-text {
  color: #64748b;
  font-size: 1.1rem;
}

.calculation-card {
  max-width: 1000px;
  margin: 0 auto;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.card-header {
  /* background: linear-gradient(135deg, #3b82f6, #2563eb); */
  background: linear-gradient(135deg, #3b82f6, #031d55);
  color: white;
  padding: 1rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #527CD2;
}

.liac-header {
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 40px;
}

.padding-10 {
  padding: 10px;
}

.padding-20 {
  padding: 20px;
}

.card-header .img-logo {
  background: white;
  padding: 10px;
  border-radius: 10px;
}

.card-header h2 {
  font-size: 1.8rem;
  font-weight: 600;
}

.card-header p {
  opacity: 0.9;
  font-size: 1rem;
}

.input-display-flex {
  display: flex;
  gap: 1.5rem;
  padding: 2rem;

  /* mame */
  flex-wrap: wrap; /* Allow wrapping on smaller screens */
  justify-content: center;
}

.input-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  padding: 2rem;
}

.input-group {
  display: flex;
  flex-direction: column;
  width: 13rem;
  /* mame */
  min-width: 100px;
}

@media screen and (max-width: 1024px) {
  .input-display-flex {
    gap: 1rem;
    padding: 1.5rem;
  }

  .card-header {
    flex-direction: column;
  }

  .card-header .img-logo {
    margin-right: 0;
    margin-bottom: 0.5rem;
    max-width: 120px;
  }
}

@media screen and (max-width: 768px) {
  .input-display-flex {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    align-items: center;
  }

  .input-group {
    width: 100%;
    max-width: 300px;
  }

  .calculate-btn {
    max-width: 100%;
  }

  .table-view th,
  .table-view td {
    font-size: 0.85rem;
    padding: 0.5rem;
  }

  .card-header h2 {
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 480px) {
  .dashboard-container {
    padding: 1rem;
    padding-top: 3rem;
  }

  .calculation-card {
    padding: 0.5rem;
  }

  .card-header h2 {
    font-size: 1rem;
    text-align: center;
  }

  .calc-input,
  .calc-select {
    font-size: 0.9rem;
    padding: 0.75rem;
  }

  .table-view th,
  .table-view td {
    font-size: 0.8rem;
    padding: 0.4rem;
  }
}

.input-label {
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.calc-input, .calc-select {
  padding: 0.875rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: #f9fafb;
}

.calc-input:focus, .calc-select:focus {
  outline: none;
  border-color: #3b82f6;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.calculate-btn {
  width: 100%;
  max-width: 300px;
  margin: 0 auto 1rem;
  display: block;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.calculate-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);
}

.calculate-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-content h3 {
  margin-bottom: 1.5rem;
  color: #1e293b;
  font-size: 1.25rem;
  font-weight: 600;
  text-align: center;
}

.modal-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
}

.modal-buttons .btn {
  flex: 1 1;
  max-width: 150px;
}

.w-100P {
  width: 100%;
}

.results-section {
  background: #f8fafc;
  padding: 2rem;
  border-top: 1px solid #e5e7eb;
}

.results-section h3 {
  text-align: center;
  color: #1e293b;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.results-grid {
  display: grid;
  /* grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); */
  grid-template-columns: 3fr 1fr;
  gap: 1rem;
}

.result-item {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border: 1px solid #f1f5f9;
}

.result-label {
  font-size: 0.85rem;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.result-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
}

/* Messages */
.message {
  position: fixed;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  padding: 1rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.message.success {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.message.error {
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

/* Admin Dashboard Styles */
.admin-container {
  max-width: 70%;
  margin: 0 20%;
  padding: 2rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}

.margin-10 {
  margin: 10px;
}

.h-3rem {
  height: 3rem
}

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f1f5f9;
}

.admin-header h2 {
  color: #1e293b;
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.admin-stats {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  justify-content: center;
}

.stat-card {
  background: linear-gradient(135deg, #f8fafc, #e2e8f0);
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  flex: 1 1;
  text-align: center;
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: #3b82f6;
  margin-bottom: 0.5rem;
}

.stat-label {
  color: #64748b;
  font-size: 0.9rem;
  font-weight: 500;
}

.search-section {
  margin-bottom: 2rem;
  text-align: center;
}

.search-container {
  position: relative;
  max-width: 400px;
  margin: 0 auto;
}

.search-input {
  padding: 0.875rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  width: 100%;
  background: #f9fafb;
  transition: all 0.2s ease;
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 1.1rem;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
}

.users-table th {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.users-table td {
  padding: 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
  vertical-align: middle;
}

.users-table tr:hover {
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
}

.users-table tr:last-child td {
  border-bottom: none;
}

.action-buttons {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}

.btn-small {
  padding: 0.6rem 1.2rem;
  font-size: 0.875rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
  min-width: 100px;
  text-align: center;
}

.btn-small:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.btn-small.btn-role {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  color: white;
}

.btn-small.btn-role:hover {
  background: linear-gradient(135deg, #7c3aed, #6d28d9);
}

.btn-small.btn-password {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white;
}

.btn-small.btn-password:hover {
  background: linear-gradient(135deg, #d97706, #b45309);
}

.btn-small.btn-delete {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
}

.btn-small.btn-delete:hover {
  background: linear-gradient(135deg, #dc2626, #b91c1c);
}

.role-select {
  padding: 0.6rem 1rem;
  font-size: 0.875rem;
  border-radius: 6px;
  border: 2px solid #e5e7eb;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.role-select:hover {
  border-color: #3b82f6;
}

.role-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.role-badge {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.role-badge.user {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}

.role-badge.superuser {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white;
}

.role-badge.admin {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
}

.user-id {
  font-weight: 600;
  color: #6b7280;
  font-family: 'Courier New', monospace;
}

.user-email {
  font-weight: 500;
  color: #1e293b;
}

.edit-password-section {
  margin-top: 1rem;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.edit-password-section input {
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  margin-right: 0.5rem;
  font-size: 0.875rem;
}

.empty-state {
  text-align: center;
  padding: 3rem 2rem;
  color: #6b7280;
}

.empty-state-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.empty-state-text {
  font-size: 1.1rem;
  font-weight: 500;
}

.loading-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #f3f4f6;
  border-radius: 50%;
  border-top-color: #3b82f6;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .auth-layout {
    flex-direction: column;
  }
  
  .auth-image-section {
    height: 200px;
    flex: none;
  }
  
  .auth-form-section {
    padding: 1rem;
  }
  
  .auth-card {
    padding: 1.5rem;
  }
  
  .brand-name {
    font-size: 1.5rem;
  }
  
  .auth-title {
    font-size: 1.1rem;
  }
  
  .dashboard-container {
    padding: 1rem;
    padding-top: 4rem;
  }
  
  .dashboard-header h1 {
    font-size: 2rem;
  }
  
  .input-grid {
    grid-template-columns: 1fr;
    padding: 1.5rem;
  }
  
  .card-header {
    padding: 1.5rem;
  }
  
  .results-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
  
  .header-controls {
    top: 1rem;
    right: 1rem;
    flex-direction: column;
  }
  
  .admin-container {
    max-width: 95%;
    padding: 1rem;
  }
  
  .admin-header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .admin-stats {
    flex-direction: column;
  }
  
  .users-table {
    font-size: 0.875rem;
  }
  
  .action-buttons {
    flex-direction: row;
    gap: 0.5rem;
  }
  
  .btn-small {
    min-width: 80px;
    padding: 0.5rem 0.8rem;
    font-size: 0.8rem;
  }
  
  .modal-content {
    padding: 1.5rem;
    margin: 1rem;
  }
  
  .modal-buttons {
    flex-direction: column;
  }
  
  .modal-buttons .btn {
    max-width: none;
  }
}

@media (max-width: 480px) {
  .auth-card {
    padding: 1rem;
  }
  
  .input-grid {
    padding: 1rem;
  }
}

.flex-col {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.results-section {
  margin-top: 20px;
  padding: 40px 20px 20px 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.results-grid {
  display: grid;
  grid-template-columns: 1fr 2fr; /* 2 columns, second one is wider */
  grid-template-rows: auto auto auto; /* 3 rows */
  gap: 10px;
}

.result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.result-item .result-label {
  font-weight: bold;
  color: #333;
}

.result-item .result-value {
  color: #666;
}

/* Custom styles for each row/column */
.row1-col1 {
  grid-column: 1;
  grid-row: 1;
}

.row1-col2 {
  grid-column: 2;
  grid-row: 1;
}

.row2-col1 {
  grid-column: 1;
  grid-row: 2;
}

.row3-col1 {
  grid-column: 1;
  grid-row: 3;
}

.row4-col1 {
  grid-column: 1;
  grid-row: 4;
}

.row5-col1 {
  grid-column: 1;
  grid-row: 5;
}

.row6-col1 {
  grid-column: 1;
  grid-row: 6; 
}

/* Merged cells: spanning across rows and columns */
.merged-cell-2 {
  grid-column: 2; /* Column 2 */
  grid-row: 2 / span 2; /* Spanning both row 2 and 3 */
  background-color: #e0f7fa; /* Light blue background for merged cell */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
}

.merged-cell-4 {
  grid-column: 2; /* Column 2 */
  grid-row: 2 / span 4; /* Spanning both row 2 and 3 */
  background-color: #e0f7fa; /* Light blue background for merged cell */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
}

.merged-cell-5 {
  grid-column: 2; /* Column 2 */
  grid-row: 2 / span 5; /* Spanning both row 2 and 3 */
  background-color: #e0f7fa; /* Light blue background for merged cell */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
}

.table-view {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.table-view th {
  padding: 10px;
  text-align: center;
  border: 1px solid #ddd;
}

.table-view td {
  padding: 10px;
  text-align: left;
  border: 1px solid #ddd;
}

.table-view th {
  background-color: #f4f4f4;
  font-weight: bold;
}

.merged-cell {
  background-color: #e0f7fa;
  text-align: center;
  vertical-align: middle;
}

.table-head-font {
  background: darkblue !important;
  color: white !important;
}

.width-25p {
  width: 25%;
}

.width-75p {
  width: 75%;
}

.text-ali-cen {
  text-align: center !important;
}

.ft-w-500 {
  font-weight: 500;
}

.print-btn-wrapper {
  display: flex;
  justify-content: center;
}

@media print {
  /* Hide non-essential elements during print */
  .header-controls,
  .dashboard-header,
  .input-display-flex,
  .print-btn-h,
  .print-btn-wrapper,
  .calculate-btn {
    display: none !important;
  }

  .dis-none, .card-header, .print-only {
    display: block !important; /* show elements with dis-none for print */
  }

  button {
    display: none !important;
  }

  /* Ensure the body and table fill the page correctly */
  body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif !important;
    background: white !important;
  }

  .app-container,
  .dashboard-container {
    min-height: auto !important;
    background: white !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .calculation-card {
    max-width: none !important;
    margin: 0 !important;
    background: white !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    overflow: visible !important;
  }

  .results-section {
    background: white !important;
    padding: 0 !important;
    border-top: none !important;
    margin-top: 0 !important;

    /* mame */
    overflow-x: auto;
  }

  /* Make sure there is no padding on the container */
  .padding-20 {
    padding: 10px !important;
  }

  /* Make table take full width, and reset any extra styles */
  .table-view {
    width: 100% !important; /* Ensure full width */
    border-collapse: collapse;
    margin-bottom: 15px !important;
    page-break-inside: avoid;
    /* mame */
    min-width: 320px;
  }

  @media screen and (max-width: 768px) {
  .table-view th,
  .table-view td {
    padding: 8px;
    font-size: 0.9rem;
  }

  .col-title,
  .col-value {
    display: block;
    width: 100%;
  }

  .merged-cell {
    display: block;
    width: 100%;
    margin-top: 5px;
  }

  .table-view thead {
    display: none; /* hide headers on mobile */
  }

  .table-view tbody tr {
    display: block;
    margin-bottom: 15px;
    border-bottom: 2px solid #ddd;
  }

  .table-view tbody td {
    display: flex;
    justify-content: space-between;
    padding: 8px;
    border: none;
    border-bottom: 1px solid #eee;
  }

  .table-view tbody td::before {
    content: attr(data-label);
    font-weight: bold;
    text-transform: uppercase;
    width: 50%;
  }
}

  .table-view th, .table-view td {
    padding: 8px !important; /* Ensure consistent padding */
    text-align: left;
    border: 1px solid #ddd !important; /* Make sure borders are consistent */
    font-size: 11px !important;
    line-height: 1.3 !important;
  }

  /* Table header styling */
  .table-view th {
    background-color: #f4f4f4 !important;
    font-weight: bold !important;
    color: #333 !important;
  }

  .table-head-font {
    background: #1e3a8a !important;
    color: white !important;
    font-weight: bold !important;
  }

  .width-25p {
    width: 25% !important;
  }

  .width-75p {
    width: 75% !important;
  }

  .ft-w-500 {
    font-weight: 500 !important;
    font-size: 11px !important;
  }

  .text-ali-cen {
    text-align: center !important;
  }

  .merged-cell {
    background-color: #e0f7fa !important;
    text-align: center !important;
    vertical-align: middle !important;
    font-weight: bold !important;
  }

  /* Page setup to prevent overflow and scaling */
  @page {
    size: A4;
    margin: 15mm;
  }

  /* Prevent page breaks within table rows */
  .table-view tr {
    page-break-inside: avoid;
  }

  /* Add some spacing between tables */
  .table-view + div {
    margin-top: 10px !important;
  }

  /* Ensure input values table prints properly */
  .table-view:first-child {
    margin-bottom: 20px !important;
  }

  /* Hide any buttons or interactive elements */
  button {
    display: none !important;
  }

  /* Ensure input values table prints properly */
  .table-view:first-child {
    margin-bottom: 20px !important;
  }

  /* Hide any buttons or interactive elements */
  button {
    display: none !important;
  }
}

.dis-none {
  display: none !important;
}

.print-only {
  display: none; /* hide on screen */
}

/* Footer Styles */
.app-footer {
  background: linear-gradient(135deg, #1e293b, #334155);
  color: white;
  padding: 2rem 0;
  margin-top: auto;
  border-top: 1px solid #e5e7eb;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1.5rem;
}

.footer-logo {
  background: white;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}

.footer-logo:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.footer-logo img {
  height: 60px;
  width: auto;
  object-fit: contain;
}

.footer-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-company {
  font-size: 1.5rem;
  font-weight: 700;
  color: #f8fafc;
  letter-spacing: 1px;
}

.footer-tagline {
  font-size: 1rem;
  color: #cbd5e1;
  font-style: italic;
}

.footer-divider {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #475569, transparent);
  margin: 0.5rem 0;
}

.footer-copyright {
  font-size: 0.9rem;
  color: #94a3b8;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: center;
}

.footer-copyright-with-image {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: center;
  flex-wrap: wrap;
}

.footer-copyright-image {
  height: 24px;
  width: auto;
  object-fit: contain;
  border-radius: 4px;
  background: white;
  padding: 2px;
}
.footer-links {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.footer-link {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: #60a5fa;
  text-decoration: underline;
}

/* Responsive Footer */
@media (max-width: 768px) {
  .app-footer {
    padding: 1.5rem 0;
  }
  
  .footer-content {
    padding: 0 1rem;
    gap: 1rem;
  }
  
  .footer-logo img {
    height: 50px;
  }
  
  .footer-company {
    font-size: 1.3rem;
  }
  
  .footer-tagline {
    font-size: 0.9rem;
  }
  
  .footer-copyright {
    font-size: 0.8rem;
  }
  
  .footer-copyright-with-image {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .footer-copyright-image {
    height: 20px;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 0.5rem;
  }
}

/* Ensure footer stays at bottom */
.app-container {
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1 1;
}
/* Edit Dashboard Styles */
.tab-navigation {
  display: flex;
  gap: 0.5rem;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 1.5rem;
}

.tab-button {
  padding: 0.75rem 1.5rem;
  border: none;
  background: none;
  color: #6b7280;
  font-weight: 500;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.tab-button:hover {
  color: #374151;
}

.tab-button.active {
  color: #3b82f6;
  border-bottom-color: #3b82f6;
}

.config-section {
  background: #f8fafc;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.config-section h3 {
  margin-bottom: 1.5rem;
  color: #1e293b;
  font-size: 1.25rem;
  font-weight: 600;
}

.zone-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.zone-card {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.zone-card h4 {
  margin-bottom: 1rem;
  color: #1e293b;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
  padding: 0.5rem;
  background: #f1f5f9;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .tab-navigation {
    flex-direction: column;
  }
  
  .zone-grid {
    grid-template-columns: 1fr;
  }
  
  .config-section {
    padding: 1rem;
  }
}

.tabs-container-edit {
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  padding: 15px;
}

.tabs-edit {
  display: flex;
  position: relative;
  background-color: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.tab-btn-edit {
  flex: 1 1;
  padding: 12px 20px;
  background: none;
  border: none;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.3s, background-color 0.3s;
  color: #555;
  position: relative;
  z-index: 1;
}

.tab-btn-edit:hover {
  color: #2e7cc5;
}

.tab-btn-edit.active {
  color: #fff;
  font-weight: 600;
}

.tab-indicator-edit {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50%; /* Two tabs, so 50% */
  height: 100%;
  background-color: #2e7cc5;
  border-radius: 8px;
  z-index: 0;
  transition: transform 0.3s ease;
}

.admin-container-ad {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.tabs-ad {
  display: flex;
  position: relative;
  background-color: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
}

.tab-btn-ad {
  flex: 1 1;
  padding: 12px 20px;
  background: none;
  border: none;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  color: #555;
  position: relative;
  z-index: 1;
}

.tab-btn-ad:hover {
  color: #2e7cc5;
}

.tab-btn-ad.active {
  color: #fff;
  font-weight: 600;
}

.tab-indicator-ad {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%; /* 2 tabs → 50% each */
  height: 100%;
  background-color: #2e7cc5;
  border-radius: 8px;
  z-index: 0;
  transition: transform 0.3s ease;
}

.tab-content-ad {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.users-table-ad {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

.users-table-ad th, .users-table-ad td {
  padding: 10px;
  border-bottom: 1px solid #eee;
  text-align: left;
}

.role-badge-ad {
  padding: 2px 6px;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  text-transform: capitalize;
}

.role-badge-ad.admin { background: #2e7cc5; }
.role-badge-ad.superuser { background: #f39c12; }
.role-badge-ad.user { background: #16a085; }

.action-buttons-ad button {
  margin-right: 5px;
}

.stat-card-ad {
  display: inline-block;
  padding: 15px 20px;
  margin: 10px;
  background: #f0f7ff;
  border-radius: 8px;
  text-align: center;
}

.stat-number-ad {
  font-size: 24px;
  font-weight: bold;
  color: #2e7cc5;
}

.modal-overlay-ad {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display:flex;
  justify-content:center;
  align-items:center;
  z-index: 999;
}

.modal-ad {
  background:#fff;
  padding:20px;
  border-radius:8px;
  min-width:300px;
}

.modal-actions-ad {
  margin-top:15px;
  text-align:right;
}

.modal-actions-ad button {
  margin-left:10px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iHAAiH;EACjH,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;;EAEb,SAAS;EACT,eAAe,EAAE,sCAAsC;EACvD,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iEAAiE;EACjE,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,SAAS;IACT,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,mCAAmC;EACnE,kCAAkC,EAAE,WAAW;EAC/C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA,mDAAmD;AACnD;EACE,cAAc,EAAE,aAAa;EAC7B,oBAAoB,EAAE,8BAA8B;EACpD,yBAAyB,EAAE,0CAA0C;EACrE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,oBAAoB,EAAE,8BAA8B;EACpD,yBAAyB,EAAE,0CAA0C;EACrE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,oBAAoB,EAAE,8BAA8B;EACpD,yBAAyB,EAAE,0CAA0C;EACrE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;EAC7C;;;;;;IAME,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB,EAAE,0CAA0C;EACvE;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,sDAAsD;EACtD;IACE,SAAS;IACT,UAAU;IACV,yCAAyC;IACzC,4BAA4B;EAC9B;;EAEA;;IAEE,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;IAC3B,wBAAwB;;IAExB,SAAS;IACT,gBAAgB;EAClB;;EAEA,mDAAmD;EACnD;IACE,wBAAwB;EAC1B;;EAEA,2DAA2D;EAC3D;IACE,sBAAsB,EAAE,sBAAsB;IAC9C,yBAAyB;IACzB,8BAA8B;IAC9B,wBAAwB;IACxB,SAAS;IACT,gBAAgB;EAClB;;EAEA;EACA;;IAEE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa,EAAE,2BAA2B;EAC5C;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,UAAU;EACZ;AACF;;EAEE;IACE,uBAAuB,EAAE,8BAA8B;IACvD,gBAAgB;IAChB,iCAAiC,EAAE,qCAAqC;IACxE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA,yBAAyB;EACzB;IACE,oCAAoC;IACpC,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA,+CAA+C;EAC/C;IACE,QAAQ;IACR,YAAY;EACd;;EAEA,0CAA0C;EAC1C;IACE,wBAAwB;EAC1B;;EAEA,oCAAoC;EACpC;IACE,2BAA2B;EAC7B;;EAEA,8CAA8C;EAC9C;IACE,8BAA8B;EAChC;;EAEA,6CAA6C;EAC7C;IACE,wBAAwB;EAC1B;;EAEA,8CAA8C;EAC9C;IACE,8BAA8B;EAChC;;EAEA,6CAA6C;EAC7C;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa,EAAE,mBAAmB;AACpC;;AAEA,kBAAkB;AAClB;EACE,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qEAAqE;EACrE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;AACA,0BAA0B;AAC1B;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,6CAA6C;EAC7C,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU,EAAE,qBAAqB;EACjC,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU,EAAE,sBAAsB;EAClC,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,0BAA0B;AAC5B;;AAEA,uBAAuB,mBAAmB,EAAE;AAC5C,2BAA2B,mBAAmB,EAAE;AAChD,sBAAsB,mBAAmB,EAAE;;AAE3C;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\r\n  background: #f8fafc;\r\n  line-height: 1.6;\r\n}\r\n\r\n.app-container {\r\n  min-height: 100vh;\r\n  position: relative;\r\n}\r\n\r\n/* Authentication Layout */\r\n.auth-layout {\r\n  display: flex;\r\n  min-height: 100vh;\r\n}\r\n\r\n.auth-image-section {\r\n  flex: 1;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.auth-image-section img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  opacity: 0.9;\r\n}\r\n\r\n.auth-form-section {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1.5rem;\r\n  background: white;\r\n}\r\n\r\n.auth-card {\r\n  width: 100%;\r\n  max-width: 400px;\r\n  padding: 2rem;\r\n}\r\n\r\n/* Brand Section */\r\n.brand-section {\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.brand-logo {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.brand-name {\r\n  display: block;\r\n  font-size: 1.8rem;\r\n  font-weight: 800;\r\n  color: #1e293b;\r\n  letter-spacing: 1px;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.brand-tagline {\r\n  display: block;\r\n  font-size: 0.85rem;\r\n  color: #64748b;\r\n  font-style: italic;\r\n}\r\n\r\n.auth-title {\r\n  color: #3b82f6;\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n/* Form Styles */\r\n.auth-form {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.form-label {\r\n  display: block;\r\n  margin-bottom: 0.5rem;\r\n  color: #374151;\r\n  font-weight: 500;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.form-input {\r\n  width: 100%;\r\n  padding: 0.875rem 1rem;\r\n  border: 2px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  transition: all 0.2s ease;\r\n  background: #f9fafb;\r\n}\r\n\r\n.form-input:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  background: white;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.password-input-container {\r\n  position: relative;\r\n}\r\n\r\n.password-toggle {\r\n  position: absolute;\r\n  right: 1rem;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  color: #6b7280;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  padding: 0.25rem;\r\n}\r\n\r\n.password-toggle:hover {\r\n  color: #374151;\r\n}\r\n\r\n/* Button Styles */\r\n.btn {\r\n  padding: 0.875rem 1.5rem;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  text-align: center;\r\n}\r\n\r\n.btn-primary {\r\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\r\n  color: white;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: linear-gradient(135deg, #2563eb, #1d4ed8);\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\r\n}\r\n\r\n.btn-primary:disabled {\r\n  background: #9ca3af;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.btn-secondary {\r\n  background: #6b7280;\r\n  color: white;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: #4b5563;\r\n}\r\n\r\n.btn-danger {\r\n  background: #ef4444;\r\n  color: white;\r\n}\r\n\r\n.btn-danger:hover {\r\n  background: #dc2626;\r\n}\r\n\r\n.btn-link {\r\n  background: none;\r\n  color: #3b82f6;\r\n  border: none;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  font-size: 0.95rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.btn-link:hover {\r\n  color: #2563eb;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Switch Text */\r\n.switch-text {\r\n  text-align: center;\r\n  color: #6b7280;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n/* Footer */\r\n.footer-text {\r\n  text-align: center;\r\n  font-size: 0.8rem;\r\n  color: #9ca3af;\r\n  margin-top: 2rem;\r\n  padding-top: 1.5rem;\r\n  border-top: 1px solid #f3f4f6;\r\n}\r\n\r\n.footer-link {\r\n  color: #3b82f6;\r\n  text-decoration: none;\r\n}\r\n\r\n.footer-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Header Controls */\r\n.header-controls {\r\n  position: fixed;\r\n  top: 1.5rem;\r\n  right: 1.5rem;\r\n  z-index: 1000;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.session-error {\r\n  text-align: center;\r\n  padding: 10px;\r\n  color: red;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Dashboard Styles */\r\n.dashboard-container {\r\n  min-height: 100vh;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\r\n  padding: 2rem;\r\n  padding-top: 5rem;\r\n}\r\n\r\n.dashboard-header {\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.dashboard-header h1 {\r\n  color: #1e293b;\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.welcome-text {\r\n  color: #64748b;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.calculation-card {\r\n  max-width: 1000px;\r\n  margin: 0 auto;\r\n  background: white;\r\n  border-radius: 16px;\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);\r\n  overflow: hidden;\r\n}\r\n\r\n.card-header {\r\n  /* background: linear-gradient(135deg, #3b82f6, #2563eb); */\r\n  background: linear-gradient(135deg, #3b82f6, #031d55);\r\n  color: white;\r\n  padding: 1rem;\r\n  text-align: center;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.main-header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  color: #527CD2;\r\n}\r\n\r\n.liac-header {\r\n  font-size: 24px;\r\n  font-weight: 800;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.padding-10 {\r\n  padding: 10px;\r\n}\r\n\r\n.padding-20 {\r\n  padding: 20px;\r\n}\r\n\r\n.card-header .img-logo {\r\n  background: white;\r\n  padding: 10px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.card-header h2 {\r\n  font-size: 1.8rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.card-header p {\r\n  opacity: 0.9;\r\n  font-size: 1rem;\r\n}\r\n\r\n.input-display-flex {\r\n  display: flex;\r\n  gap: 1.5rem;\r\n  padding: 2rem;\r\n\r\n  /* mame */\r\n  flex-wrap: wrap; /* Allow wrapping on smaller screens */\r\n  justify-content: center;\r\n}\r\n\r\n.input-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: 1.5rem;\r\n  padding: 2rem;\r\n}\r\n\r\n.input-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 13rem;\r\n  /* mame */\r\n  min-width: 100px;\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .input-display-flex {\r\n    gap: 1rem;\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .card-header {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .card-header .img-logo {\r\n    margin-right: 0;\r\n    margin-bottom: 0.5rem;\r\n    max-width: 120px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .input-display-flex {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    padding: 1rem;\r\n    align-items: center;\r\n  }\r\n\r\n  .input-group {\r\n    width: 100%;\r\n    max-width: 300px;\r\n  }\r\n\r\n  .calculate-btn {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .table-view th,\r\n  .table-view td {\r\n    font-size: 0.85rem;\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  .card-header h2 {\r\n    font-size: 1.2rem;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .dashboard-container {\r\n    padding: 1rem;\r\n    padding-top: 3rem;\r\n  }\r\n\r\n  .calculation-card {\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  .card-header h2 {\r\n    font-size: 1rem;\r\n    text-align: center;\r\n  }\r\n\r\n  .calc-input,\r\n  .calc-select {\r\n    font-size: 0.9rem;\r\n    padding: 0.75rem;\r\n  }\r\n\r\n  .table-view th,\r\n  .table-view td {\r\n    font-size: 0.8rem;\r\n    padding: 0.4rem;\r\n  }\r\n}\r\n\r\n.input-label {\r\n  font-weight: 600;\r\n  color: #374151;\r\n  margin-bottom: 0.5rem;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.calc-input, .calc-select {\r\n  padding: 0.875rem;\r\n  border: 2px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  transition: all 0.2s ease;\r\n  background: #f9fafb;\r\n}\r\n\r\n.calc-input:focus, .calc-select:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  background: white;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.calculate-btn {\r\n  width: 100%;\r\n  max-width: 300px;\r\n  margin: 0 auto 1rem;\r\n  display: block;\r\n  padding: 1rem 2rem;\r\n  background: linear-gradient(135deg, #10b981, #059669);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.calculate-btn:hover:not(:disabled) {\r\n  background: linear-gradient(135deg, #059669, #047857);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);\r\n}\r\n\r\n.calculate-btn:disabled {\r\n  background: #9ca3af;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n}\r\n\r\n/* Modal Styles */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  padding: 2rem;\r\n  border-radius: 12px;\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\r\n  max-width: 500px;\r\n  width: 90%;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal-content h3 {\r\n  margin-bottom: 1.5rem;\r\n  color: #1e293b;\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n.modal-buttons {\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: center;\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.modal-buttons .btn {\r\n  flex: 1;\r\n  max-width: 150px;\r\n}\r\n\r\n.w-100P {\r\n  width: 100%;\r\n}\r\n\r\n.results-section {\r\n  background: #f8fafc;\r\n  padding: 2rem;\r\n  border-top: 1px solid #e5e7eb;\r\n}\r\n\r\n.results-section h3 {\r\n  text-align: center;\r\n  color: #1e293b;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.results-grid {\r\n  display: grid;\r\n  /* grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); */\r\n  grid-template-columns: 3fr 1fr;\r\n  gap: 1rem;\r\n}\r\n\r\n.result-item {\r\n  background: white;\r\n  padding: 1.5rem;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  border: 1px solid #f1f5f9;\r\n}\r\n\r\n.result-label {\r\n  font-size: 0.85rem;\r\n  color: #64748b;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.result-value {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #1e293b;\r\n}\r\n\r\n/* Messages */\r\n.message {\r\n  position: fixed;\r\n  top: 1rem;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 1rem 1.5rem;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  z-index: 1000;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.message.success {\r\n  background: #dcfce7;\r\n  color: #166534;\r\n  border: 1px solid #bbf7d0;\r\n}\r\n\r\n.message.error {\r\n  background: #fef2f2;\r\n  color: #991b1b;\r\n  border: 1px solid #fecaca;\r\n}\r\n\r\n/* Admin Dashboard Styles */\r\n.admin-container {\r\n  max-width: 70%;\r\n  margin: 0 20%;\r\n  padding: 2rem;\r\n  background: white;\r\n  border-radius: 16px;\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.margin-10 {\r\n  margin: 10px;\r\n}\r\n\r\n.h-3rem {\r\n  height: 3rem\r\n}\r\n\r\n.admin-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 2px solid #f1f5f9;\r\n}\r\n\r\n.admin-header h2 {\r\n  color: #1e293b;\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  margin: 0;\r\n}\r\n\r\n.admin-stats {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-bottom: 2rem;\r\n  justify-content: center;\r\n}\r\n\r\n.stat-card {\r\n  background: linear-gradient(135deg, #f8fafc, #e2e8f0);\r\n  padding: 1.5rem;\r\n  border-radius: 12px;\r\n  border: 1px solid #e5e7eb;\r\n  flex: 1;\r\n  text-align: center;\r\n}\r\n\r\n.stat-number {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: #3b82f6;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.stat-label {\r\n  color: #64748b;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.search-section {\r\n  margin-bottom: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.search-container {\r\n  position: relative;\r\n  max-width: 400px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.search-input {\r\n  padding: 0.875rem 1rem;\r\n  border: 2px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  width: 100%;\r\n  background: #f9fafb;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.search-input:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  background: white;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.search-icon {\r\n  position: absolute;\r\n  right: 1rem;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #9ca3af;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.users-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background: white;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n  border: 1px solid #f1f5f9;\r\n}\r\n\r\n.users-table th {\r\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\r\n  color: white;\r\n  padding: 1rem;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.users-table td {\r\n  padding: 1rem;\r\n  border-bottom: 1px solid #f1f5f9;\r\n  color: #1e293b;\r\n  vertical-align: middle;\r\n}\r\n\r\n.users-table tr:hover {\r\n  background: linear-gradient(135deg, #f8fafc, #f1f5f9);\r\n}\r\n\r\n.users-table tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.action-buttons {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.btn-small {\r\n  padding: 0.6rem 1.2rem;\r\n  font-size: 0.875rem;\r\n  border-radius: 6px;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  font-weight: 500;\r\n  min-width: 100px;\r\n  text-align: center;\r\n}\r\n\r\n.btn-small:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.btn-small.btn-role {\r\n  background: linear-gradient(135deg, #8b5cf6, #7c3aed);\r\n  color: white;\r\n}\r\n\r\n.btn-small.btn-role:hover {\r\n  background: linear-gradient(135deg, #7c3aed, #6d28d9);\r\n}\r\n\r\n.btn-small.btn-password {\r\n  background: linear-gradient(135deg, #f59e0b, #d97706);\r\n  color: white;\r\n}\r\n\r\n.btn-small.btn-password:hover {\r\n  background: linear-gradient(135deg, #d97706, #b45309);\r\n}\r\n\r\n.btn-small.btn-delete {\r\n  background: linear-gradient(135deg, #ef4444, #dc2626);\r\n  color: white;\r\n}\r\n\r\n.btn-small.btn-delete:hover {\r\n  background: linear-gradient(135deg, #dc2626, #b91c1c);\r\n}\r\n\r\n.role-select {\r\n  padding: 0.6rem 1rem;\r\n  font-size: 0.875rem;\r\n  border-radius: 6px;\r\n  border: 2px solid #e5e7eb;\r\n  background: white;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  min-width: 120px;\r\n}\r\n\r\n.role-select:hover {\r\n  border-color: #3b82f6;\r\n}\r\n\r\n.role-select:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.role-badge {\r\n  display: inline-block;\r\n  padding: 0.4rem 0.8rem;\r\n  border-radius: 20px;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.role-badge.user {\r\n  background: linear-gradient(135deg, #10b981, #059669);\r\n  color: white;\r\n}\r\n\r\n.role-badge.superuser {\r\n  background: linear-gradient(135deg, #f59e0b, #d97706);\r\n  color: white;\r\n}\r\n\r\n.role-badge.admin {\r\n  background: linear-gradient(135deg, #ef4444, #dc2626);\r\n  color: white;\r\n}\r\n\r\n.user-id {\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n.user-email {\r\n  font-weight: 500;\r\n  color: #1e293b;\r\n}\r\n\r\n.edit-password-section {\r\n  margin-top: 1rem;\r\n  padding: 1rem;\r\n  background: #f8fafc;\r\n  border-radius: 8px;\r\n  border: 1px solid #e5e7eb;\r\n}\r\n\r\n.edit-password-section input {\r\n  padding: 0.5rem;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  margin-right: 0.5rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.empty-state {\r\n  text-align: center;\r\n  padding: 3rem 2rem;\r\n  color: #6b7280;\r\n}\r\n\r\n.empty-state-icon {\r\n  font-size: 3rem;\r\n  margin-bottom: 1rem;\r\n  opacity: 0.5;\r\n}\r\n\r\n.empty-state-text {\r\n  font-size: 1.1rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.loading-spinner {\r\n  display: inline-block;\r\n  width: 20px;\r\n  height: 20px;\r\n  border: 2px solid #f3f4f6;\r\n  border-radius: 50%;\r\n  border-top-color: #3b82f6;\r\n  animation: spin 1s ease-in-out infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .auth-layout {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .auth-image-section {\r\n    height: 200px;\r\n    flex: none;\r\n  }\r\n  \r\n  .auth-form-section {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .auth-card {\r\n    padding: 1.5rem;\r\n  }\r\n  \r\n  .brand-name {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .auth-title {\r\n    font-size: 1.1rem;\r\n  }\r\n  \r\n  .dashboard-container {\r\n    padding: 1rem;\r\n    padding-top: 4rem;\r\n  }\r\n  \r\n  .dashboard-header h1 {\r\n    font-size: 2rem;\r\n  }\r\n  \r\n  .input-grid {\r\n    grid-template-columns: 1fr;\r\n    padding: 1.5rem;\r\n  }\r\n  \r\n  .card-header {\r\n    padding: 1.5rem;\r\n  }\r\n  \r\n  .results-grid {\r\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\r\n  }\r\n  \r\n  .header-controls {\r\n    top: 1rem;\r\n    right: 1rem;\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .admin-container {\r\n    max-width: 95%;\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .admin-header {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    text-align: center;\r\n  }\r\n  \r\n  .admin-stats {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .users-table {\r\n    font-size: 0.875rem;\r\n  }\r\n  \r\n  .action-buttons {\r\n    flex-direction: row;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .btn-small {\r\n    min-width: 80px;\r\n    padding: 0.5rem 0.8rem;\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .modal-content {\r\n    padding: 1.5rem;\r\n    margin: 1rem;\r\n  }\r\n  \r\n  .modal-buttons {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .modal-buttons .btn {\r\n    max-width: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .auth-card {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .input-grid {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n.flex-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n}\r\n\r\n.results-section {\r\n  margin-top: 20px;\r\n  padding: 40px 20px 20px 20px;\r\n  background-color: #f9f9f9;\r\n  border-radius: 8px;\r\n}\r\n\r\n.results-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 2fr; /* 2 columns, second one is wider */\r\n  grid-template-rows: auto auto auto; /* 3 rows */\r\n  gap: 10px;\r\n}\r\n\r\n.result-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.result-item .result-label {\r\n  font-weight: bold;\r\n  color: #333;\r\n}\r\n\r\n.result-item .result-value {\r\n  color: #666;\r\n}\r\n\r\n/* Custom styles for each row/column */\r\n.row1-col1 {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n}\r\n\r\n.row1-col2 {\r\n  grid-column: 2;\r\n  grid-row: 1;\r\n}\r\n\r\n.row2-col1 {\r\n  grid-column: 1;\r\n  grid-row: 2;\r\n}\r\n\r\n.row3-col1 {\r\n  grid-column: 1;\r\n  grid-row: 3;\r\n}\r\n\r\n.row4-col1 {\r\n  grid-column: 1;\r\n  grid-row: 4;\r\n}\r\n\r\n.row5-col1 {\r\n  grid-column: 1;\r\n  grid-row: 5;\r\n}\r\n\r\n.row6-col1 {\r\n  grid-column: 1;\r\n  grid-row: 6; \r\n}\r\n\r\n/* Merged cells: spanning across rows and columns */\r\n.merged-cell-2 {\r\n  grid-column: 2; /* Column 2 */\r\n  grid-row: 2 / span 2; /* Spanning both row 2 and 3 */\r\n  background-color: #e0f7fa; /* Light blue background for merged cell */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 12px;\r\n}\r\n\r\n.merged-cell-4 {\r\n  grid-column: 2; /* Column 2 */\r\n  grid-row: 2 / span 4; /* Spanning both row 2 and 3 */\r\n  background-color: #e0f7fa; /* Light blue background for merged cell */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 12px;\r\n}\r\n\r\n.merged-cell-5 {\r\n  grid-column: 2; /* Column 2 */\r\n  grid-row: 2 / span 5; /* Spanning both row 2 and 3 */\r\n  background-color: #e0f7fa; /* Light blue background for merged cell */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 12px;\r\n}\r\n\r\n.table-view {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 20px;\r\n}\r\n\r\n.table-view th {\r\n  padding: 10px;\r\n  text-align: center;\r\n  border: 1px solid #ddd;\r\n}\r\n\r\n.table-view td {\r\n  padding: 10px;\r\n  text-align: left;\r\n  border: 1px solid #ddd;\r\n}\r\n\r\n.table-view th {\r\n  background-color: #f4f4f4;\r\n  font-weight: bold;\r\n}\r\n\r\n.merged-cell {\r\n  background-color: #e0f7fa;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n}\r\n\r\n.table-head-font {\r\n  background: darkblue !important;\r\n  color: white !important;\r\n}\r\n\r\n.width-25p {\r\n  width: 25%;\r\n}\r\n\r\n.width-75p {\r\n  width: 75%;\r\n}\r\n\r\n.text-ali-cen {\r\n  text-align: center !important;\r\n}\r\n\r\n.ft-w-500 {\r\n  font-weight: 500;\r\n}\r\n\r\n.print-btn-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n@media print {\r\n  /* Hide non-essential elements during print */\r\n  .header-controls,\r\n  .dashboard-header,\r\n  .input-display-flex,\r\n  .print-btn-h,\r\n  .print-btn-wrapper,\r\n  .calculate-btn {\r\n    display: none !important;\r\n  }\r\n\r\n  .dis-none, .card-header, .print-only {\r\n    display: block !important; /* show elements with dis-none for print */\r\n  }\r\n\r\n  button {\r\n    display: none !important;\r\n  }\r\n\r\n  /* Ensure the body and table fill the page correctly */\r\n  body {\r\n    margin: 0;\r\n    padding: 0;\r\n    font-family: Arial, sans-serif !important;\r\n    background: white !important;\r\n  }\r\n\r\n  .app-container,\r\n  .dashboard-container {\r\n    min-height: auto !important;\r\n    background: white !important;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .calculation-card {\r\n    max-width: none !important;\r\n    margin: 0 !important;\r\n    background: white !important;\r\n    border-radius: 0 !important;\r\n    box-shadow: none !important;\r\n    overflow: visible !important;\r\n  }\r\n\r\n  .results-section {\r\n    background: white !important;\r\n    padding: 0 !important;\r\n    border-top: none !important;\r\n    margin-top: 0 !important;\r\n\r\n    /* mame */\r\n    overflow-x: auto;\r\n  }\r\n\r\n  /* Make sure there is no padding on the container */\r\n  .padding-20 {\r\n    padding: 10px !important;\r\n  }\r\n\r\n  /* Make table take full width, and reset any extra styles */\r\n  .table-view {\r\n    width: 100% !important; /* Ensure full width */\r\n    border-collapse: collapse;\r\n    margin-bottom: 15px !important;\r\n    page-break-inside: avoid;\r\n    /* mame */\r\n    min-width: 320px;\r\n  }\r\n\r\n  @media screen and (max-width: 768px) {\r\n  .table-view th,\r\n  .table-view td {\r\n    padding: 8px;\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .col-title,\r\n  .col-value {\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n\r\n  .merged-cell {\r\n    display: block;\r\n    width: 100%;\r\n    margin-top: 5px;\r\n  }\r\n\r\n  .table-view thead {\r\n    display: none; /* hide headers on mobile */\r\n  }\r\n\r\n  .table-view tbody tr {\r\n    display: block;\r\n    margin-bottom: 15px;\r\n    border-bottom: 2px solid #ddd;\r\n  }\r\n\r\n  .table-view tbody td {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 8px;\r\n    border: none;\r\n    border-bottom: 1px solid #eee;\r\n  }\r\n\r\n  .table-view tbody td::before {\r\n    content: attr(data-label);\r\n    font-weight: bold;\r\n    text-transform: uppercase;\r\n    width: 50%;\r\n  }\r\n}\r\n\r\n  .table-view th, .table-view td {\r\n    padding: 8px !important; /* Ensure consistent padding */\r\n    text-align: left;\r\n    border: 1px solid #ddd !important; /* Make sure borders are consistent */\r\n    font-size: 11px !important;\r\n    line-height: 1.3 !important;\r\n  }\r\n\r\n  /* Table header styling */\r\n  .table-view th {\r\n    background-color: #f4f4f4 !important;\r\n    font-weight: bold !important;\r\n    color: #333 !important;\r\n  }\r\n\r\n  .table-head-font {\r\n    background: #1e3a8a !important;\r\n    color: white !important;\r\n    font-weight: bold !important;\r\n  }\r\n\r\n  .width-25p {\r\n    width: 25% !important;\r\n  }\r\n\r\n  .width-75p {\r\n    width: 75% !important;\r\n  }\r\n\r\n  .ft-w-500 {\r\n    font-weight: 500 !important;\r\n    font-size: 11px !important;\r\n  }\r\n\r\n  .text-ali-cen {\r\n    text-align: center !important;\r\n  }\r\n\r\n  .merged-cell {\r\n    background-color: #e0f7fa !important;\r\n    text-align: center !important;\r\n    vertical-align: middle !important;\r\n    font-weight: bold !important;\r\n  }\r\n\r\n  /* Page setup to prevent overflow and scaling */\r\n  @page {\r\n    size: A4;\r\n    margin: 15mm;\r\n  }\r\n\r\n  /* Prevent page breaks within table rows */\r\n  .table-view tr {\r\n    page-break-inside: avoid;\r\n  }\r\n\r\n  /* Add some spacing between tables */\r\n  .table-view + div {\r\n    margin-top: 10px !important;\r\n  }\r\n\r\n  /* Ensure input values table prints properly */\r\n  .table-view:first-child {\r\n    margin-bottom: 20px !important;\r\n  }\r\n\r\n  /* Hide any buttons or interactive elements */\r\n  button {\r\n    display: none !important;\r\n  }\r\n\r\n  /* Ensure input values table prints properly */\r\n  .table-view:first-child {\r\n    margin-bottom: 20px !important;\r\n  }\r\n\r\n  /* Hide any buttons or interactive elements */\r\n  button {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.dis-none {\r\n  display: none !important;\r\n}\r\n\r\n.print-only {\r\n  display: none; /* hide on screen */\r\n}\r\n\r\n/* Footer Styles */\r\n.app-footer {\r\n  background: linear-gradient(135deg, #1e293b, #334155);\r\n  color: white;\r\n  padding: 2rem 0;\r\n  margin-top: auto;\r\n  border-top: 1px solid #e5e7eb;\r\n}\r\n\r\n.footer-content {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 0 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.footer-logo {\r\n  background: white;\r\n  padding: 1rem 1.5rem;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.footer-logo:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.footer-logo img {\r\n  height: 60px;\r\n  width: auto;\r\n  object-fit: contain;\r\n}\r\n\r\n.footer-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.footer-company {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #f8fafc;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.footer-tagline {\r\n  font-size: 1rem;\r\n  color: #cbd5e1;\r\n  font-style: italic;\r\n}\r\n\r\n.footer-divider {\r\n  width: 100%;\r\n  height: 1px;\r\n  background: linear-gradient(90deg, transparent, #475569, transparent);\r\n  margin: 0.5rem 0;\r\n}\r\n\r\n.footer-copyright {\r\n  font-size: 0.9rem;\r\n  color: #94a3b8;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n  align-items: center;\r\n}\r\n\r\n.footer-copyright-with-image {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.footer-copyright-image {\r\n  height: 24px;\r\n  width: auto;\r\n  object-fit: contain;\r\n  border-radius: 4px;\r\n  background: white;\r\n  padding: 2px;\r\n}\r\n.footer-links {\r\n  display: flex;\r\n  gap: 1rem;\r\n  align-items: center;\r\n}\r\n\r\n.footer-link {\r\n  color: #3b82f6;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.footer-link:hover {\r\n  color: #60a5fa;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Responsive Footer */\r\n@media (max-width: 768px) {\r\n  .app-footer {\r\n    padding: 1.5rem 0;\r\n  }\r\n  \r\n  .footer-content {\r\n    padding: 0 1rem;\r\n    gap: 1rem;\r\n  }\r\n  \r\n  .footer-logo img {\r\n    height: 50px;\r\n  }\r\n  \r\n  .footer-company {\r\n    font-size: 1.3rem;\r\n  }\r\n  \r\n  .footer-tagline {\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .footer-copyright {\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .footer-copyright-with-image {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .footer-copyright-image {\r\n    height: 20px;\r\n  }\r\n  \r\n  .footer-links {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n  }\r\n}\r\n\r\n/* Ensure footer stays at bottom */\r\n.app-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.main-content {\r\n  flex: 1;\r\n}\r\n/* Edit Dashboard Styles */\r\n.tab-navigation {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  border-bottom: 2px solid #e5e7eb;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.tab-button {\r\n  padding: 0.75rem 1.5rem;\r\n  border: none;\r\n  background: none;\r\n  color: #6b7280;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  border-bottom: 2px solid transparent;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.tab-button:hover {\r\n  color: #374151;\r\n}\r\n\r\n.tab-button.active {\r\n  color: #3b82f6;\r\n  border-bottom-color: #3b82f6;\r\n}\r\n\r\n.config-section {\r\n  background: #f8fafc;\r\n  padding: 1.5rem;\r\n  border-radius: 8px;\r\n  border: 1px solid #e5e7eb;\r\n}\r\n\r\n.config-section h3 {\r\n  margin-bottom: 1.5rem;\r\n  color: #1e293b;\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.zone-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 1.5rem;\r\n}\r\n\r\n.zone-card {\r\n  background: white;\r\n  padding: 1.5rem;\r\n  border-radius: 8px;\r\n  border: 1px solid #e5e7eb;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.zone-card h4 {\r\n  margin-bottom: 1rem;\r\n  color: #1e293b;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  padding: 0.5rem;\r\n  background: #f1f5f9;\r\n  border-radius: 4px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .tab-navigation {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .zone-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .config-section {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n.tabs-container-edit {\r\n  position: relative;\r\n  margin-bottom: 20px;\r\n  width: 100%;\r\n  padding: 15px;\r\n}\r\n\r\n.tabs-edit {\r\n  display: flex;\r\n  position: relative;\r\n  background-color: #f5f5f5;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.1);\r\n}\r\n\r\n.tab-btn-edit {\r\n  flex: 1;\r\n  padding: 12px 20px;\r\n  background: none;\r\n  border: none;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  transition: color 0.3s, background-color 0.3s;\r\n  color: #555;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.tab-btn-edit:hover {\r\n  color: #2e7cc5;\r\n}\r\n\r\n.tab-btn-edit.active {\r\n  color: #fff;\r\n  font-weight: 600;\r\n}\r\n\r\n.tab-indicator-edit {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 50%; /* Two tabs, so 50% */\r\n  height: 100%;\r\n  background-color: #2e7cc5;\r\n  border-radius: 8px;\r\n  z-index: 0;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.admin-container-ad {\r\n  padding: 20px;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.tabs-ad {\r\n  display: flex;\r\n  position: relative;\r\n  background-color: #f5f5f5;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.tab-btn-ad {\r\n  flex: 1;\r\n  padding: 12px 20px;\r\n  background: none;\r\n  border: none;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  color: #555;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.tab-btn-ad:hover {\r\n  color: #2e7cc5;\r\n}\r\n\r\n.tab-btn-ad.active {\r\n  color: #fff;\r\n  font-weight: 600;\r\n}\r\n\r\n.tab-indicator-ad {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 50%; /* 2 tabs → 50% each */\r\n  height: 100%;\r\n  background-color: #2e7cc5;\r\n  border-radius: 8px;\r\n  z-index: 0;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.tab-content-ad {\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\r\n}\r\n\r\n.users-table-ad {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 15px;\r\n}\r\n\r\n.users-table-ad th, .users-table-ad td {\r\n  padding: 10px;\r\n  border-bottom: 1px solid #eee;\r\n  text-align: left;\r\n}\r\n\r\n.role-badge-ad {\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.role-badge-ad.admin { background: #2e7cc5; }\r\n.role-badge-ad.superuser { background: #f39c12; }\r\n.role-badge-ad.user { background: #16a085; }\r\n\r\n.action-buttons-ad button {\r\n  margin-right: 5px;\r\n}\r\n\r\n.stat-card-ad {\r\n  display: inline-block;\r\n  padding: 15px 20px;\r\n  margin: 10px;\r\n  background: #f0f7ff;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n}\r\n\r\n.stat-number-ad {\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  color: #2e7cc5;\r\n}\r\n\r\n.modal-overlay-ad {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0,0,0,0.5);\r\n  display:flex;\r\n  justify-content:center;\r\n  align-items:center;\r\n  z-index: 999;\r\n}\r\n\r\n.modal-ad {\r\n  background:#fff;\r\n  padding:20px;\r\n  border-radius:8px;\r\n  min-width:300px;\r\n}\r\n\r\n.modal-actions-ad {\r\n  margin-top:15px;\r\n  text-align:right;\r\n}\r\n\r\n.modal-actions-ad button {\r\n  margin-left:10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
